/* tslint:disable */
import { Component } from './component';

/**
 */
export class ViewComponents {
    active?: Component[];
    sleeping?: Component[];
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-components.ts